module.exports = __webpack_public_path__ + "static/media/step-one-small.2260aa7b.webp";